













import { Component, Vue } from 'vue-property-decorator';
import { MentoringNumber } from './components';
import { IMentoringProcess } from './types';
import steps from './consts';

@Component({
  components: {
    MentoringNumber,
  },
})
export default class MentoringProcess extends Vue implements IMentoringProcess {
  public items: Array<string> = steps;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/process/MentoringProcess.vue